import React from "react";
import { useHistory } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
import { Routes } from "@lifeat/shared/system/RouteConstants";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import ChevronLeftIcon from "@icons/ChevronLeftArrow.svg";
import DesktopAppIcon from "@resources/logos/desktopApp/LifeAt_DesktopApp_MenubarIcon.svg";
import { lightTheme } from "@themes/Theme";
import { buildRoute } from "@util/RouteUtil";

const InfoPageWrapper = styled.div<{ forceLightMode?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100dvh;
    width: 100vw;
    overflow: scroll;
    background: inherit;
    background-color: ${(props) =>
        props.forceLightMode ? lightTheme.backgroundPrimary : props.theme.backgroundPrimary};
`;

const InfoPageBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    height: 100%;
    width: 100%;
`;

const ControlStrip = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: auto;
    padding: 2px 4px;
`;

const StyledChevronLeftIcon = styled(ChevronLeftIcon)<{ forceLightMode?: boolean }>`
    fill: ${(props) => (props.forceLightMode ? lightTheme.iconColor : props.theme.iconColor)};
`;

const Logo = styled.div`
    height: 64px;
    width: 64px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: black;
    border-radius: 12px;

    margin-bottom: 25px;
`;

interface InfoPageTemplateProps {
    children: JSX.Element | JSX.Element[];
    forceLightMode?: boolean;
    showNavBarOverride?: boolean;
    showLogo?: boolean;
    className?: string;
}
function InfoPageTemplate(props: InfoPageTemplateProps) {
    const history = useHistory();

    const { user, userData }: UserContextType = useUserContext();

    const page = (
        <InfoPageWrapper forceLightMode={props.forceLightMode}>
            {(!!window.todesktop || props.showNavBarOverride) && (
                <ControlStrip>
                    <LifeAtButtonV2
                        variant={"ghost"}
                        disableHover={true}
                        onClick={() => {
                            if (user && userData) {
                                history.goBack();
                            } else {
                                history.push(buildRoute(Routes.App));
                            }
                        }}
                    >
                        <StyledChevronLeftIcon />
                        <span> Back</span>
                    </LifeAtButtonV2>
                </ControlStrip>
            )}

            <InfoPageBody className={props.className}>
                {props.showLogo && (
                    <Logo>
                        <DesktopAppIcon />
                    </Logo>
                )}
                {props.children}
            </InfoPageBody>
        </InfoPageWrapper>
    );

    return props.forceLightMode ? <ThemeProvider theme={lightTheme}>{page}</ThemeProvider> : page;
}

export default InfoPageTemplate;
